module.exports = __webpack_public_path__ + "img/skillDP.0e3df858.svg";